import React, { CSSProperties, useEffect } from "react";
import styled from "styled-components";
import Ask from "./Ask";
import MainVisual from "./MainVisual";
import ECSVerticalScroll from "./intro/ECSVerticalScroll";
import ECSRVerticalScroll from "./intro/ECSRVerticalScroll";
import Footer from "./Footer";
import Summary from "./Summary";
import Overview from "./Overview";
import PageTop from "./PageTop";
import { IUADevice, userAgentInfo } from "../model/UserAgentInfo";
import { useMediaQuery } from "@material-ui/core";
import { OrientationContext, OrientationEnum } from "../provider/OrientationProvider";
import { MAX_WIDTH, MAX_WIDTH_STR } from "../model/Const";
import mangaInfo from "../model/MangaInfo";


// 直前のメディアクエリの値（この結果によってreloadするかどうかを決定するが、再レンダリングには影響しないのでstateではなく外出しで管理）
let prevSmallMedia: boolean;
let localOrientation: OrientationEnum;

const All: React.FC = () => {
	// 紹介画像を縦スクロールタイプにするかどうかの判定用メディアクエリ
	const isSmallMedia = useMediaQuery( "(max-width: 500px) and (orientation: portrait)" );

	// コンテキスト
	const context = React.useContext( OrientationContext );

	const [mainShow, setMainShow] = React.useState( false );

	// 初回1回だけ
	React.useEffect( () => {
		// 初回時点のisSmallMediaを保存
		prevSmallMedia = isSmallMedia;

		// メインビジュアルの表示チェック
		function confirmDisplay():void{
			// 読み込み完了していたらtrueに入る
			if(mangaInfo.mainLoaded){
				// メインビジュアルが表示されたことを通知
				setMainShow(true);

				// インターバルはクリア（終了）
				clearInterval(id);
				// console.log("finish!!")
			}

			// console.log("continue!")
		}

		// 100msごとにメインビジュアルの表示チェック
		const id= setInterval(confirmDisplay, 100);
	}, [] );

	// リサイズorメディアクエリの変更時に呼ばれる
	// React.useEffect( () => {
	// 	// prevがundefined（初期化前）あるいはPC以外の端末だったらreturn
	// 	if ( prevSmallMedia === undefined || userAgentInfo.device !== IUADevice.pc ) {
	// 		return;
	// 	}
	//
	// 	// PC以外で、スクロール画像がうまく更新されないので強制リロード
	// 	if ( prevSmallMedia && isSmallMedia ) {
	// 		window.location.reload();
	// 		return;
	// 	}
	//
	// 	// それ以外は更新して終わり
	// 	prevSmallMedia = isSmallMedia;
	// }, [isSmallMedia] );

	useEffect( () => {
		if ( localOrientation === undefined ) {
			localOrientation = context.orientation;
			return;
		}
		// pc以外だったらリロードする
		if ( userAgentInfo.device !== IUADevice.pc ) {
			// window.location.reload();
			window.scrollTo( 0, 0 );
			return;
		}
	}, [ context.orientation ] );

	// 最大幅を設定するスタイル（PCの場合のみ設定）
	const maxWidthStyle = React.useMemo( () => {
		// 幅が最大幅より大きく、PCだったら最大幅を指定
		if ( window.innerWidth > MAX_WIDTH && userAgentInfo.device === IUADevice.pc ) {
			return {
				max: {
					maxWidth: MAX_WIDTH_STR,
					margin: "auto"
				} as CSSProperties,
			}
		}

		return {
			max: undefined,
		};
	}, [ context.resize ] );

	return <div style={{ overflow: "hidden" }}>
		{/*メインビジュアル*/}
		<MainVisual/>

		{( () => {
			// 読み込み前は表示しない
			if ( !mainShow ) {
				return <div
					style={{
						height: "100%",
						width: "100%",
						background: "linear-gradient(0deg, rgb(223, 0, 58), #ffb03c)",
						color: "white"
					}}
				>
					Now Loading...
				</div>;
			}
			return <>

				{/*問いかけ*/}
				<section>
					<Ask/>

					{/*概要*/}
					<Overview/>
				</section>

				{/*eCS+まんが*/}
				<ECSVerticalScroll
					isSmallMedia={isSmallMedia}
				/>

				{/*eCSRまんが*/}
				<ECSRVerticalScroll
					isSmallMedia={isSmallMedia}
				/>

				{/*サマリー*/}
				<Summary/>

				{/*フッター*/}
				<Footer style={maxWidthStyle.max}/>

				{/*ページトップ*/}
				<PageTop/>

			</>
		} )()}

	</div>;
};

export default All;